<i18n
  src="@/locales/views/customer/query/basic_containers/list_agro_exporters.yml"
  lang="yaml"
></i18n>
<template>
  <bread-crumbs :labels="[module_name]"></bread-crumbs>

  <div
    v-if="load_data_general"
    class="bg-white shadow overflow-hidden sm:rounded-md mt-8"
  >
    <ul role="list" class="divide-y divide-slate-200">
      <li v-for="agro_exporter in agro_exporters" :key="agro_exporter.id">
        <div
          class="block hover:bg-slate-50 cursor-pointer"
          @click.prevent="goToContainers(agro_exporter)"
        >
          <div class="px-4 py-4 sm:px-6">
            <div class="flex items-center justify-between">
              <p class="text-sm font-medium text-gray-900 truncate">
                {{ agro_exporter.name }}
              </p>
              <div class="ml-2 flex-shrink-0 flex">
                <a class="link invisible sm:visible">
                  <i class="fa-solid fa-eye"></i>
                  <span class="space-icon"></span>{{ $t("labels.show_link") }}
                </a>
              </div>
            </div>
            <div class="mt-2 sm:flex sm:justify-between">
              <div class="sm:flex space-x-0 sm:space-x-6">
                <p
                  v-for="(
                    number_containers, index
                  ) in agro_exporter.number_containers"
                  :key="index"
                  class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0"
                >
                  <i
                    class="fa-solid fa-container-storage flex-shrink-0"
                    aria-hidden="true"
                  />
                  <span class="space-icon"></span>
                  {{ number_containers.name }}:
                  {{ number_containers.count_all }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
  <template v-else>
    <loading-message />
  </template>
</template>

<script>
import Requester from "@/views/customer/requesters/query/basic_containers/list_agro_exporters.js";

export default {
  name: "ListAgroExporters",
  props: {
    customer_id: { required: true }
  },
  data: function () {
    return {
      load_data_general: false,
      agro_exporters: null
    };
  },
  methods: {
    fetchAgroExporters: async function () {
      const response = await Requester.fetchAgroExporters(this.customer_id);
      this.agro_exporters = response.data;
      this.load_data_general = true;
    },
    goToContainers: function (agro_exporter) {
      this.$router.push({
        name: this.routeName("list_containers"),
        params: {
          customer_id: this.customer_id,
          agro_exporter_id: agro_exporter.id
        }
      });
    }
  },
  created: function () {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          customer_id: this.customer_id
        }
      }).then(() => this.fetchAgroExporters())
    );
  }
};
</script>
